import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { LoginComponent } from '@core/login/login.component';
import { AuthGuard } from '@shared/services/guards/auth-guard.service';
import {PasswordExpiryComponent} from '@app/password-expiry/password-expiry.component';

export const AppRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  }, {
    path: 'passwordexpiry',
    component: PasswordExpiryComponent
  } , {
    path: '',
    component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
    }],
    canActivate: [AuthGuard]
  }, {
    path: '**',
    redirectTo: ''
  }

]
